import { Button, Checkbox, Col, Form, message, Modal, Row, Select, Spin, Tooltip } from "antd"
import QueueAnim from 'rc-queue-anim'
import { DatePickerWithMask, UIPageListing } from "../../components"
import { useEffect, useRef, useState } from "react";
import { employeesService, reportService } from "../../redux/services";
import { API_ERRO_TYPE_CANCEL } from "../../config/general";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";

const config = {
	title: "Comprovantes",
	permissionPrefix: "funcionarios",
};

const Signatures = ({ permissions }) => {
    const axiosCancelEmployeesToken = useRef(null);

    const [employeesIsLoading, setEmployeesIsLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selectedMap, setSelectedMap] = useState({});
    const [selectedAll, setSelectedAll] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 50 });
    const [loadingSingleReceipt, setLoadingSingleReceipt] = useState(false);
    const [loadingMultipleReceipt, setLoadingMultipleReceipt] = useState(false);

    const [form] = Form.useForm();

    const selectedItems = Object.keys(selectedMap).map(Number);
    const selectedUuids = Object.values(selectedMap);
    
    const fetchEmployees = (value) => {
        if (axiosCancelEmployeesToken.current) {
            axiosCancelEmployeesToken.current.cancel(
                'Only one request allowed at a time.'
            );
        }

        axiosCancelEmployeesToken.current = axios.CancelToken.source()

        setEmployeesIsLoading(true);

        let params = {
            search: value,
            ativo: 1,
            orderBy: 'nome:asc',
            cancelToken: axiosCancelEmployeesToken.current.token,
        }

        employeesService
            .getAutocomplete({
                ...params,
            })
            .then((response) => {
                setEmployeesIsLoading(false);
                setEmployees(response.data.data);
            })
            .catch((data) => {
                if (data.error_type === API_ERRO_TYPE_CANCEL) return null

                setEmployeesIsLoading(false);

                Modal.error({
                    title: 'Ocorreu um erro!',
                    content: String(data),
                })
            })
    }

    const onEmployeeChange = (value) => {
        if (value?.length > 1 && value.includes('todos')) {
            form.setFieldValue(
                'funcionarios',
                value.filter((item) => item !== 'todos')
            );
        }
    }

    const onEmployeeSelect = (value) => {
        if (value === 'todos') {
            form.setFieldValue('funcionarios', ['todos']);
        }
    }

    const onFinish = () => {
        fetchData();
    }

    const fetchData = (paginationObject) => {
        setLoading(true);

        const { current, pageSize } = paginationObject || pagination;
        const { funcionarios, data_inicio, data_fim } = form.getFieldsValue();

        if (!data_inicio) {}

        const payload = {
            paginacao: pageSize,
            page: current,
        }

        payload.data_inicial = data_inicio ? moment(data_inicio).format('YYYY-MM-DD') : moment().startOf('month').format('YYYY-MM-DD');
        payload.data_final = moment(data_fim).format('YYYY-MM-DD');

        if (funcionarios?.length > 0 && !funcionarios.includes('todos')) {
            payload.funcionario_ids = funcionarios;
        }

        if (status !== 'todos') {
            payload.status = status;
        }

        reportService.receipts(payload)
            .then(({ data }) => {
                setData(data.data);
                setPagination({
                    ...pagination,
                    total: data.total,
                    current,
                    pageSize,
                })

                if (data.data.length < 1) {
                    setSelectedAll(false);
                }

                if (selectedAll) {
                    setSelectedMap(prev => {
                        const newState = { ...prev };

                        data.data.forEach(item => {
                            if (item.uuid) {
                                newState[item.id] = item.uuid;
                            }
                        });

                        return newState;
                    });
                }
                setLoading(false);
            }).catch((data) => {
                console.log('error', data);
                message.error('Ocorreu um erro ao listar os comprovantes, tente novamente!');
                setLoading(false);
            });
    }

	const onPaginationChange = (page, pageSize) => {
        const newPaginationObject = {
            ...pagination,
            current: page,
            pageSize,
        }
        setPagination(newPaginationObject);
        fetchData(newPaginationObject);
	};

    const dowloadMultiplosComprovantes = async () => {
        setLoadingMultipleReceipt(true);
        const payload = {
            dowloadAllFiltered: selectedAll,
        };

        if (selectedAll) {
            const { funcionarios, data_inicio, data_fim, status } = form.getFieldsValue();

            payload.data_inicial = moment(data_inicio).format('YYYY-MM-DD');
            payload.data_final = moment(data_fim).format('YYYY-MM-DD');

            if (funcionarios?.length > 0 && !funcionarios.includes('todos')) {
                payload.funcionario_ids = funcionarios;
            }

        } else {
            payload.uuids = selectedUuids;
        }

        try {
            const response = await reportService.dowloadReceiptMultiple(payload);

            const { data } = response;

            const url = window.URL.createObjectURL(new Blob([data]));

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `comprovantes_${moment().format('DD/MM/YYYY_HH:mm')}.zip`); // nome do arquivo
            document.body.appendChild(link);
            link.click();

            link.remove();
            setLoadingMultipleReceipt(false);

        } catch (error) {
            console.log(error);
            setLoadingMultipleReceipt(false);
            if (error.error.response && error.error.response.data instanceof Blob) {
                const reader = new FileReader();

                reader.onload = () => {
                    try {
                        const errorData = JSON.parse(reader.result);
                        console.error("Mensagem do servidor:", errorData.message);

                        Modal.error({
                            title  : "Ocorreu um erro!",
                            content: String(errorData.message),
                        });
                    } catch (e) {
                        console.error("Erro ao processar JSON de erro", e);
                    }
                };

                reader.readAsText(error.error.response.data);
            } else {
                Modal.error({
                    title  : "Ocorreu um erro!",
                    content: String(error.message),
                });
            }
        }
    }

    const selectItem = ({ id, uuid }) => {
        if (!uuid) {
            console.warn('Item sem UUID:', id);
            return;
        }

        setSelectedMap(prev => {
            const newState = { ...prev };

            if (newState[id]) {
                delete newState[id];
                setSelectedAll(false);
            } else {
                newState[id] = uuid;
            }

            return newState;
        });
    };

    const selectAll = (event) => {
        const isChecked = event.target.checked;

        if (isChecked) {
            setSelectedAll(true);

            setSelectedMap(prev => {
                const newState = { ...prev };

                data.forEach(item => {
                    if (item.uuid) {
                        newState[item.id] = item.uuid;
                    }
                });

                return newState;
            });
        } else {
            setSelectedAll(false);
            setSelectedMap({});
        }
    };

    const dowloadReceipt = async (ponto_registro_id) => {
        setLoadingSingleReceipt(true);

        await reportService.dowloadReceipt({ ponto_registro_id })
            .then(({ data }) => {
                setLoadingSingleReceipt(false);
                window.open(data.file_url);
            }).catch((data) => {
                console.log('error', data);
                message.error('Ocorreu um erro ao baixar o comprovante, tente novamente!');
                setLoadingSingleReceipt(false);
            });
    }

    useEffect(() => {
        fetchEmployees('');
        fetchData(pagination);
    }, []);

    const columns = [
        {
            title: 'REP-P',
            width: 80,
            render: (item) => <div>1</div>
        },
        {
            title: 'NSR',
            width: 80,
            render: (item) => <div>{item.nsr}</div>
        },
        {
            title: 'Data e Horário',
            width: 150,
            render: (item) => <div>{moment(item.data).format("DD/MM/YYYY HH:mm")}</div>
        },
        {
            title: 'Hash',
            render: (item) => <div>{item.codigo_hash}</div>
        },
        {
            title: 'Funcionário',
            width: 200,
            render: (item) => <div>{item.funcionario.nome}</div>
        },
        {
            title: "",
            className: "actions no-ellipsis",
            render: (item) => <div>
                <Tooltip title="Baixar comprovante">
                    <a onClick={() => dowloadReceipt(item.id)}>
                        <i className="fal fa-file" />
                    </a>
                </Tooltip>
            </div>
        },
    ];


    const totalSelectedItems = selectedAll ? pagination.total : selectedItems.length;

    return (
      <QueueAnim className="site-content-inner alternative-wrapper">
        <div className="page-content fixed-header point-receipt-list" key="1">
            <h1 className="page-title">Comprovante de Registro de Ponto</h1>
            <Form
                form={form}
                layout="vertical"
                scrollToFirstError
                onFinish={onFinish}
                // className="form-signatures-list"
                initialValues={{
                required: true,
                funcionarios: ['todos'],
                data_inicio: moment().startOf('month'),
                data_fim: moment(),
                }}
            >
                <Row gutter={16} align="middle">
                <Col xs={24} md={8}>
                    <Form.Item
                    name="funcionarios"
                    label="Funcionário"
                    hasFeedback
                    rules={[{ required: true, message: 'Campo obrigatório.' }]}
                    >
                    <Select
                        mode="multiple"
                        filterOption={false}
                        allowClear
                        placeholder="Selecione o(s) funcionário(s)"
                        notFoundContent={
                        employeesIsLoading ? (
                            <Spin
                            indicator={
                                <i className="fad fa-spinner-third fa-spin" />
                            }
                            />
                        ) : null
                        }
                        onSearch={fetchEmployees}
                        onChange={onEmployeeChange}
                        onSelect={onEmployeeSelect}
                        showSearch
                    >
                        <Select.Option value="todos">Todos</Select.Option>
                        {employees.map((item, index) => (
                        <Select.Option key={index} value={item.id}>
                            {item.nome}
                        </Select.Option>
                        ))}
                    </Select>
                    </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={4} xxl={4}>
                    <DatePickerWithMask
                    onKeyUp={(e) => {
                        if (e.keyCode === 13 || e.keyCode === 9) {
                        form.data_fim.focus()
                        }
                    }}
                    label="Data Início"
                    name="data_inicio"
                    required={true}
                    rules={[
                        {
                        required: true,
                        message: 'Campo obrigatório.',
                        },
                        {
                        validator: async (_, data_inicio) => {
                            var data_fim = form.getFieldValue('data_fim')
                            if (data_fim !== null) {
                            if (data_inicio > data_fim) {
                                return Promise.reject(
                                'A data inicial deve ser menor ou igual a data final.'
                                )
                            }
                            }
                        },
                        },
                    ]}
                    />
                </Col>
                <Col xs={24} md={12} lg={4} xxl={4}>
                    <DatePickerWithMask
                    label="Data Fim"
                    name="data_fim"
                    onKeyUp={(e) => {
                        if (e.keyCode === 13 || e.keyCode === 9) {
                        form.data_inicio.focus()
                        }
                    }}
                    required={true}
                    rules={[
                        {
                        required: true,
                        message: 'Campo obrigatório.',
                        },
                        {
                        validator: async (_, data_fim) => {
                            var data_inicio = form.getFieldValue('data_inicio')
                            if (data_inicio !== null) {
                            if (data_fim < data_inicio) {
                                return Promise.reject(
                                'A data final deve ser maior ou igual a data inicial.'
                                )
                            }
                            }
                        },
                        },
                    ]}
                    />
                </Col>
                
                <Row gutter={16} align='middle'>
                    <div>
                    <Button
                        type="primary"
                        htmlType="submit"
                        shape="round"
                        className="btn-save"
                        icon={<i className="far fa-check" />}
                        loading={loading}
                        disabled={loading}
                        style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', marginLeft: 15 }}
                    >
                        Buscar
                    </Button>
                    </div>
                </Row>
                </Row>
            </Form>

            {(permissions.includes(config.permissionPrefix + ".edit") || permissions.includes(config.permissionPrefix + ".edit")) && 
                <div style={{ display: 'flex', justifyContent: 'space-between' }} className="selection-actions">
                    {data.length > 0 && <Checkbox onChange={selectAll} checked={selectedAll}>Selecionar todos</Checkbox>}
                    {(selectedItems.length > 0 || selectedAll) && (<div style={{ display: 'flex', alignItems: 'flex-end'}}>
                        <span>{`${totalSelectedItems} ${totalSelectedItems > 1 ? 'itens selecionados' : 'item selecionado'}`}</span>
                        <Button
                            shape="round"
                            className="btn-save"
                            size="small"
                            icon={<i className="fas fa-download" />}
                            // loading={loading}
                            onClick={() => dowloadMultiplosComprovantes()}
                            disabled={loading}
                            style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', marginLeft: 15 }}
                        >
                            Baixar Selecionados
                        </Button>
                    </div>)} 
                </div>
            }
            <UIPageListing
                isLoading={loading}
                listType="list"
                data={data}
                enableSearch={false}
                showListTypeChange={false}
                pagination={pagination}
                columns={columns}
                showFilters={false}
                allowSelect
                selectedItems={selectedItems}
                onSelectItem={selectItem}
                onPaginationChange={onPaginationChange}
            />
        </div>
        <Modal
            title={loadingMultipleReceipt ? 'Carregando os comprovantes. Isso pode levar alguns minutos.' : 'Carregando o comprovante.'}
            visible={loadingSingleReceipt || loadingMultipleReceipt}
            footer={null}
            closable={false}
            maskClosable={false}
        >
            <div style={{ textAlign: 'center' }}>
                <p style={{fontWeight: 500}}>Por favor, aguarde... </p>
                <Spin
                    indicator={
                    <i className="fad fa-spinner-third fa-spin" />
                    }
                />
            </div>
        </Modal>
      </QueueAnim>
    )
}

const mapStateToProps = (state, ownProps) => {
	return {
		permissions: state.auth.userData.permissions,
		listType: state.general.listType[config.list],
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		onChangeListType: (type) => {
			dispatch(generalActions.changeListType(config.list, type));
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(Signatures);